"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaveModel = void 0;
const Toast_1 = require("../toast/Toast");
const SaveModelControls_1 = require("./components/SaveModelControls");
const i18next_1 = __importDefault(require("i18next"));
class SaveModel {
    constructor(parentEl) {
        this.saveModelFunctions = {
            save: () => this.onSaving(),
            saved: (success) => this.onSaved(success)
        };
        if (!parentEl) {
            throw new Error("Parent element (saveModel) is undefined");
        }
        this.savemodelControls = new SaveModelControls_1.SaveModelControls(parentEl);
        this.addEvents();
    }
    dispose() {
        var _a;
        this.removeEvents();
        (_a = this.savemodelControls) === null || _a === void 0 ? void 0 : _a.dispose();
        delete this.savemodelControls;
    }
    addEvents() {
        var _a, _b;
        (_b = (_a = this.savemodelControls) === null || _a === void 0 ? void 0 : _a.saveModelBtn) === null || _b === void 0 ? void 0 : _b.setEvent('click', this.saveModelFunctions.save);
    }
    removeEvents() {
        var _a, _b;
        (_b = (_a = this.savemodelControls) === null || _a === void 0 ? void 0 : _a.saveModelBtn) === null || _b === void 0 ? void 0 : _b.removeEvent('click', this.saveModelFunctions.save);
    }
    onSaving() {
        var _a;
        PubSub.publish("save" /* SAVE */, this.saveModelFunctions.saved);
        (_a = this.savemodelControls) === null || _a === void 0 ? void 0 : _a.start();
    }
    onSaved(success) {
        var _a;
        (_a = this.savemodelControls) === null || _a === void 0 ? void 0 : _a.stop();
        if (success) {
            Toast_1.Toast.create('success', i18next_1.default.t("SUCCESSFULLY_SAVED"), 3000);
            return;
        }
        Toast_1.Toast.create('error', i18next_1.default.t("SAVE_FAILED"), 3000);
    }
}
exports.SaveModel = SaveModel;
